export default __webpack_public_path__ + "static/daylia_lian-a461c7fe27630438a96e11124e7f7bd8.jpg";